import { AIPrompt } from './ai-prompt.model';

export type PromptWithFailed = {
  failed?: boolean;
} & AIPrompt;

export class AIPromptView {
  containsAudio: boolean;
  prompts: PromptWithFailed[];
}
